import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

var router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "Default",
            component: (resolve) => require(["../views/HomeView"], resolve)
        }
    ],
});

export default router;
